// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__Vj8BW","loading":"Loader_loading__u5ZM-"};